module.exports = __webpack_public_path__ + "img/SWP_Axe_2H_05.59e2aeae.png";